import { useAppDispatch, useAppSelector } from "app/hooks";

import ProductPictureDialog from "./product-picture-dialog.component";
import {
  closeProductPicture,
  selectProductPicture
} from "./product-picture.slice";

// Single app-level host for the product picture dialog. Mounted alongside
// ConfirmDialog so the dialog survives the unmounting of whatever row, grid cell
// or autocomplete option triggered it.
export default function ProductPictureViewer() {
  const dispatch = useAppDispatch();
  const { open, productId } = useAppSelector(selectProductPicture);

  if (!productId) return null;

  return (
    <ProductPictureDialog
      productId={productId}
      open={open}
      onClose={() => dispatch(closeProductPicture())}
    />
  );
}
